import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import LoadingSpinner from '../../../components/LoadingSpinner';
import API from "../../../API";
import adminAPI from "../../../API/adminAPI";
import styles from "./ProductQuestions.module.css";

export default function ProductQuestions({QR, id}) {
  const navigate = useNavigate();
  const [product, setProduct] = useState({});
  const {getProduct} = API;
  const [initializing, setInitializing] = useState(false);

  const handleRedirect = async (r) => {
    try {
      setInitializing(true);
    } catch (e) {
      // Non-blocking: even if init fails, attempt navigation so user can proceed
      console.error('Retail code initialization error (non-blocking): ', e?.message || e);
    } finally {
      setInitializing(false);
    }

    if (r === "type") {
      navigate(`/collection/${id}/edit`);
    } else if (r === "start") {
      navigate(`/collection/${id}/edit?tab=configure`);
    } else {
      navigate('/notfound');
    }
  };

  useEffect(() => {
    let mounted = true;

    const handleGetProduct = async () => {
      try {
        const response = await getProduct(QR?.data?.product_id);
        mounted && setProduct(response);
      } catch (error) {
        console.error("Error getting product data: ", error.message);
        mounted && setProduct({id: "error", name: ""});
      };
    };

    if (QR?.data && QR?.data?.product_id && !product?.id) {
      handleGetProduct();
    };

    return () => {
      mounted = false;
    };
  }, [QR?.data?.product_id]);

  if (!product.id) {
    return (<LoadingSpinner />);
  };
  
  if (product.id === "error") {
    return (
      <div className={styles.container}>
        <span>An error occurred.</span>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <button className={styles.linkBtn} disabled={initializing} onClick={() => handleRedirect("start")}>
        {initializing ? 'Preparing…' : `Start your ${product?.name} QR`}
      </button>
      <div className={styles.separator}>or</div>
      <button className={styles.linkBtn} disabled={initializing} onClick={() => handleRedirect("type")}>
        {initializing ? 'Preparing…' : 'Select a different QR Type'}
      </button>
    </div>
  );
};
